import React, { useState } from 'react';

type RelativeTimeProps = {
  date: Date | string | number;
  language?: string;
};

function getRelativeTime(date: Date) {
  const now = new Date();
  const diff = (date.getTime() - now.getTime()) / 1000; // in seconds
  const absDiff = Math.abs(diff);

  let value: number;
  let unit: Intl.RelativeTimeFormatUnit;

  if (absDiff < 60) {
    value = Math.round(diff);
    unit = 'second';
  } else if (absDiff < 3600) {
    value = Math.round(diff / 60);
    unit = 'minute';
  } else if (absDiff < 86400) {
    value = Math.round(diff / 3600);
    unit = 'hour';
  } else if (absDiff < 2592000) {
    value = Math.round(diff / 86400);
    unit = 'day';
  } else if (absDiff < 31536000) {
    value = Math.round(diff / 2592000);
    unit = 'month';
  } else {
    value = Math.round(diff / 31536000);
    unit = 'year';
  }

  return { value, unit };
}

export function getRelativeTimeString(date: Date | string | number, language?: string) {
  try {
    const targetDate = new Date(date);
    const { value, unit } = getRelativeTime(targetDate);
    //const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });
    const rtf = new Intl.RelativeTimeFormat(language || undefined, { numeric: 'auto' });
    return rtf.format(value, unit);
  } catch (err) {
    console.log('Error formatting date:', err);
    return 'N/A';
  }
}

export const RelativeTime: React.FC<RelativeTimeProps> = ({ date, language }) => {
  const [_now, setNow] = useState(() => new Date());

  React.useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  try {
    const targetDate = new Date(date);
    const absoluteDate = targetDate.toLocaleString(language, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
    const relativeDateString = getRelativeTimeString(date, language);

    return (
      <span className="time--indicator" title={absoluteDate}>
        {relativeDateString}
      </span>
    );
  } catch (err) {
    return <span className="time--indicator">N/A</span>;
  }
};
